<template>
  <q-card square class="sticky-header-card">
    <div class="center-sticky-header">
      <analysis-sub-menu class="sticky-margin">
        <template v-slot:activator>
          <q-btn
            class="cursor-pointer q-ml-sm text-white bg-primary"
            @click="$emit('locale-search')"
            label="Filter"
          />
          <div
            class="sticky-add"
            style="flex:1 !important;justify-content:flex-end"
          >
            <q-btn
              :disable="resetFilterChecker"
              v-if="!resetFilterChecker"
              round
              @click="$store.commit('analysis/RESET_FILTER', true)"
              color="primary"
              size="sm"
            >
              <q-icon name="fas fa-sync-alt"></q-icon>
              <q-tooltip v-if="!resetFilterChecker">Reset Filters</q-tooltip>
            </q-btn>
          </div>
        </template>
      </analysis-sub-menu>
      <div class="sticky-sub-menu">
        <div class="filter-info">
          Filters:
          <q-badge v-if="resetFilterChecker" color="negative">NONE</q-badge>
          <q-badge
            style="margin-right:5px"
            outline
            color="positive"
            v-if="companyFilter && companyFilter.name"
            >Company :
            {{
              companyFilter && companyFilter.name ? companyFilter.name : ""
            }}</q-badge
          >
          <q-badge
            style="margin-right:5px"
            outline
            color="info"
            v-if="multiFilter > 0"
            >Locations:{{ multiFilter }}</q-badge
          >
          <q-badge
            style="margin-right:5px"
            outline
            color="info"
            v-if="statusFilter > 0"
            >Statuses:{{ statusFilter }}</q-badge
          >
          <q-badge
            style="margin-right:5px"
            outline
            color="warning"
            v-if="search"
            >Search: {{ search }}</q-badge
          >
          <q-badge style="margin-right:5px" outline color="info" v-if="provider"
            >Provider: {{ provider.name }}</q-badge
          >
        </div>
        <q-icon
          color="grey-7"
          @click="subMenu = true"
          name="fas fa-caret-down"
          class="cursor-pointer"
          size="25px"
        ></q-icon>
        <q-dialog
          v-model="subMenu"
          persistent
          transition-show="scale"
          transition-hide="scale"
        >
          <q-card style="width: 300px">
            <div class="bg-primary text-white sub-menu-title">
              <div class="text-h6">Filters</div>
              <q-icon
                @click="subMenu = false"
                name="fas fa-times"
                class="cursor-pointer"
              ></q-icon>
            </div>
            <analysis-sub-menu class="sub-menu-filters">
              <template v-slot:activator>
                <div class="row">
                  <q-btn
                    label="Close"
                    size="md"
                    @click="subMenu = false"
                    color="negative"
                    style="width:calc(50% - 5px);margin-right:5px"
                  ></q-btn>
                  <q-btn
                    size="md"
                    label="RESET"
                    color="primary"
                    :disable="resetFilterChecker"
                    style="width:calc(50%)"
                    @click="
                      $store.commit('analysis/RESET_FILTER', true);
                      subMenu = false;
                    "
                  ></q-btn>
                </div>
              </template>
            </analysis-sub-menu>
          </q-card>
        </q-dialog>
      </div>
    </div>
  </q-card>
</template>

<script>
import AnalysisSubMenu from "./AnalysisSubMenu";
import axios from "../axios/index";
export default {
  components: { AnalysisSubMenu },
  data() {
    return {
      subMenu: false,
    };
  },
  async mounted() {
    if (this.$store.state.company.companies.length === 0)
      await this.getCompanies();
  },
  methods: {
    async getCompanies() {
      const { data } = await axios.get("companies");
      this.companies = data.data;
    },
  },
  computed: {
    provider() {
      return this.$store.state.analysis.provider;
    },
    resetFilterChecker() {
      const company = this.$store.state.analysis.companyFilter.id;
      const multiFilterLength = this.$store.state.analysis.multiFilter.length;
      const statusFilterLength = this.$store.state.analysis.statusFilter.length;
      const search = this.$store.state.analysis.search;
      const provider = this.$store.state.analysis.provider;
      if (company || multiFilterLength > 0 || statusFilterLength > 0 || search || provider) return false;
      else return true;
    },
    filterCount() {
      return this.$store.getters["analysis/isFiltered"];
    },
    companies: {
      get() {
        return this.$store.state.company.companies;
      },
      set(val) {
        this.$store.commit("company/SET_USER_COMPANIES", val);
      },
    },
    companyFilter() {
      return this.$store.state.analysis.companyFilter;
    },
    multiFilter() {
      return this.$store.state.analysis.multiFilter.length;
    },
    statusFilter() {
      return this.$store.state.analysis.statusFilter.length;
    },
    search() {
      return this.$store.state.analysis.search;
    },
  },
};
</script>
